import React from 'react';
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';

import Auth from '../containers/authContainer';
// Parents containers
import Main from '../containers/mainContainer';
import Root from '../containers/rootContainer';

function AppRoutes() {
  const location2 = useLocation();
  const history2 = useNavigate();
  return (
    <Routes>
      <Route
        path="/auth/*"
        element={<Auth location={location2} history={history2} />}
      />
      <Route
        path="/app/*"
        element={<Main location={location2} history={history2} />}
      />
      <Route
        path="/*"
        element={<Root location={location2} history={history2} />}
      />
      <Route path="/" element={<Navigate to="/login" />} />
    </Routes>
  );
}

export default AppRoutes;
